module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.2cf030c6.jpeg";